import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Regexs } from '@utils/regex';
import { FilesService } from 'src/app/core/services/files.service';
import { TaskFile } from 'src/app/modules/case/interface/taskFile.interface';
import { TaskCaseService } from 'src/app/modules/case/services/taskCase.service';
import { TareaCasoService } from 'src/app/services/tareacaso.service';
import { BANCOS } from '../../../../constants/bancos.constant';
import { Banco } from '../../../../interfaces/banco';
import { CuentasOtrosBancos } from '../../../../interfaces/cuentas-otros-bancos';
import { ExcelCuentasOtrosBancosService } from '../../../../services/excel-cuentas-otros-bancos.service';
import { CaseRecordService } from 'src/app/modules/case/services/case-record.service';
import { CasesService } from 'src/app/core/services/cases.service';

@Component({
  selector: 'app-cuentas-otros-bancos',
  templateUrl: './cuentas-otros-bancos.component.html',
  styleUrls: ['./cuentas-otros-bancos.component.scss'],
})
export class CuentasOtrosBancosComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  displayedColumns: string[] = ['banco', 'numero_cuenta', 'opciones'];
  dataSource = new MatTableDataSource<any>();
  tableValues: CuentasOtrosBancos[] = [];

  formTable: FormGroup;
  formFile: FormGroup;
  submit = false;
  submitFile = false;
  bancos: Banco[] = BANCOS;
  file: TaskFile | null;

  @Input() data: { task: any };

  constructor(
    private fb: FormBuilder,
    public taskCaseService: TaskCaseService,
    private excelService: ExcelCuentasOtrosBancosService,
    private readonly filesService: FilesService,
    private readonly caseRecordService: CaseRecordService,
    private caseService: CasesService
  ) {}
  icase;
  get status() {
    return this.icase?.status == 'archived';
  }
  ngOnInit(): void {
    let caseId: any;
    if (typeof this.data.task.case == 'object') {
      caseId = this.data.task.case._id;
    } else if (typeof this.data.task.case == 'string') {
      caseId = this.data.task.case;
    }
    this.caseService.getCase(caseId).subscribe((res) => {
      this.icase = res;
    });
    const { task } = this.data;
    const values = task.data ? task.data : [];
    this.tableValues = values.table || [];

    // this.file = values.file;
    this.formTable = this.fb.group({
      banco: ['Banco Central de Venezuela', [Validators.required]],
      numero_cuenta: [
        '',
        [Validators.required, Validators.pattern(Regexs.regexAccountNumber)],
      ],
    });
    this.formFile = this.fb.group({
      file: [null],
    });

    this.initializeTable();
  }

  verificateInput(value: string) {
    return (
      this.formTable.get(value)?.invalid &&
      (this.formTable.get(value)?.dirty || this.formTable.get(value)?.touched)
    );
  }

  addData() {
    if (this.formTable.invalid || this.submit) return;
    this.submit = true;
    this.tableValues.unshift(this.formTable.value);
    this.taskCaseService
      .updateTaskCase(this.data.task._id, {
        data: { file: this.file, table: this.tableValues },
      })
      .subscribe(
        (caseUpdated) => {
          this.formTable.reset();
          this.formTable.controls['banco'].setValue(
            'Banco Central de Venezuela'
          );
          this.initializeTable();
          this.taskCaseService.taskUpdated.next({ task: caseUpdated });
          this.caseRecordService.updatedRecord.next(true);
        },
        (erorr) => {
          this.submit = false;
        }
      );
  }

  removerCuenta(index: number) {
    this.tableValues.splice(index, 1);
    this.taskCaseService
      .updateTaskCase(this.data.task._id, {
        data: { file: this.file, table: this.tableValues },
      })
      .subscribe((caseUpdated) => {
        this.initializeTable();
        this.taskCaseService.taskUpdated.next({ task: caseUpdated });
        this.caseRecordService.updatedRecord.next(true);
      });
  }

  initializeTable() {
    this.dataSource = new MatTableDataSource<CuentasOtrosBancos>(
      this.tableValues
    );
    this.dataSource.paginator = this.paginator;
    this.submit = false;
    this.submitFile = false;
  }

  selectFile(event: any) {
    if (event) {
      this.file = event.target.files[0];
    } else {
      this.clearFile();
    }
  }
  filenull: any;
  addFile() {
    const input = document.createElement('input');
    input.type = 'file';
    input.click();
    input.onchange = (ev: any) => {
      const file: File = ev.target.files[0];
      const formData = new FormData();
      formData.append('file', file);
      this.filesService.upload(formData).subscribe({
        next: (url) => {
          this.filenull = file;

          this.file = {
            url,
            name: file.name,
          };
          this.formFile.get('file').setValue(this.file);
          this.formFile.value.file = this.file;
          console.log({ file: this.file, table: this.tableValues });

          this.taskCaseService
            .updateTaskCase(this.data.task._id, {
              data: { file: this.file, table: this.tableValues },
            })
            .subscribe(() => {});
        },
      });
    };
  }
  // addFile(event: any) {
  //   console.log(event);
  //   if (event) {
  //     const input = document.createElement('input');
  //     input.type = 'file';
  //     input.click();
  //     input.onchange = (ev: any) => {
  //       const file: File = ev.target.files[0];
  //       const formData = new FormData();
  //       formData.append('file', file);
  //       this.filesService.upload(formData).subscribe({
  //         next: (url) => {
  //           this.file = {
  //             url,
  //             name: file.name,
  //           };
  //           this.taskCaseService
  //             .updateTaskCase(this.data.task._id, {
  //               data: { file: this.file, table: this.tableValues },
  //             })
  //             .subscribe(() => {});
  //         },
  //       });
  //     };
  //   } else {
  //     this.clearFile();
  //   }
  // }

  downloadExcelTemplate() {
    this.excelService.generate();
  }

  clearFile() {
    this.file = null;
    this.formFile.reset();
  }

  async saveFile() {
    if (this.submitFile) return;
    this.submitFile = true;
    const cuentas = await this.excelService.readExcelFile(this.filenull);
    if (cuentas == null) {
      this.submitFile = false;
      return;
    }
    for (let element of cuentas) {
      this.tableValues.unshift(element);
      this.taskCaseService
        .updateTaskCase(this.data.task._id, {
          data: { file: this.file, table: this.tableValues },
        })
        .subscribe(
          (caseUpdated) => {
            this.formTable.reset();
            this.formTable.controls['banco'].setValue(
              'Banco Central de Venezuela'
            );
            this.initializeTable();
            this.taskCaseService.taskUpdated.next({ task: caseUpdated });
            this.caseRecordService.updatedRecord.next(true);
          },
          (erorr) => {
            this.submit = false;
          }
        );
    }
    // this.tableValues = [...cuentas, ...this.tableValues];
    // this.taskCaseService
    //   .updateTaskCase(this.data.task._id, {
    //     data: { file: this.file, table: this.tableValues },
    //   })
    //   .subscribe(
    //     () => {
    //       this.clearFile();
    //       this.initializeTable();
    //     },
    //     (erorr) => {
    //       this.submitFile = false;
    //     }
    //   );
  }
}
